export default {    
    loading: state => state.loading,
    isPrePayment: state => state.isPrePayment,
}